<template>
    <div>
        <!--撤销单历史-->
        <header class="form-title">
            <Row>
                <Col span="22">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="选择时间">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="modifyTime"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>

                        <FormItem  label="客户">
                            <Input v-model="formdata.name"  class="formSelect-input" style="width: 150px"  />
                            <Button style="margin-left: 5px" @click="modela=true">选择</Button>
                        </FormItem>
                        <FormItem  label="开单员工">
                            <Select v-model="formdata.admin" filterable class="formSelect-input" style="width: 150px" >
                                <Option value="" >全部</Option>
                                <Option v-for="(item,index) in salesman"
                                        :value="item.id"
                                        :key="index">{{item.name}}</Option>
                            </Select>
                        </FormItem>

                        <FormItem label="店铺" v-if="isCustomerSharing==1">
                            <Select v-model="formdata.shopName" filterable style="width: 200px">
                                <Option
                                        v-if="k.isCustomerSharing==1 || k.isgeneralwarehouse=='Y'"
                                        :value="k.id"
                                        v-for="(k,v) in shopList"
                                        :key="v">{{k.name}}</Option>
                            </Select>
                        </FormItem>

                        <FormItem  label="单号">
                            <Input v-model="formdata.code"  class="formSelect-input"   style="width: 150px"  />
                            <Button type="primary" style="margin-left: 15px" @click="searchCondition">搜索</Button>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        </header>
        <section>
            <Alert v-if="pageData==''" align="center">暂无数据</Alert>
            <Card class="historyItem" :dis-hover="false" v-for="(item, index) in pageData" :key="index" @click.native="$router.push({path:'/salesListDetail',query:{id:item.id}})">
                <p slot="title" style="color: #ffaf5e">{{item.customer.name}}</p>
                <span slot="extra" v-show="item.inferiorFlag=='0' || !item.inferiorFlag"  class="typeitem">销售退换单</span>
                <span slot="extra" v-show="item.inferiorFlag=='1'" class="typeitem">销售残次品退换单</span>
                <ul class="type-content">
                    <li>  金额：{{item.paymoney}} </li>
                    <li>  单号：{{item.markcode}} </li>
                    <li>  建立时间：{{item.time}} </li>
                </ul>
                <p class="ywy">业务员：{{item.adminName}}</p>
            </Card>
        </section>
        <div class="pageTotal"   v-if="pageData!=''">
            <Page :total="page.total"
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal" />
        </div>

        <Modal
                width="1000"
                v-model="modela"
                title="添加账户">
            <div>
                <h3 style="padding-bottom: 20px">客户</h3>
                <Tag  :color="item.customerType==1?'error':'primary'"  v-for="(item, index) in customerList" v-if="item.isdel!=0 " :key="index" @click.native="checkis(item)">{{item.name}}</Tag>
            </div>
            <div slot="footer">
                <Button type="primary" @click="modela=false">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                pageData:{},
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                sendData:{
                    code:'',
                },
                modela:false,
                shopList: [],//店铺列表
                customerList:[],
                salesman:[],
                formdata:{
                    adimg:'',
                    code:'',
                    spur:'',
                    name:'',
                    shopName:''
                },
                page:{
                    total:0,
                    page:1,
                    rows:12
                },
                isCustomerSharing:0, //客户共享是否开启 0关 1开
            };

        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.isCustomerSharing = JSON.parse(localStorage.getItem('shop')).isCustomerSharing
            this.valuedate[0] =  this.fun_date(-7)
            this.valuedate[1] = this.nowTime
            this.getCustomerList()
            this.getAdminList()
            this.getShopList()
            this.getMarketList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
        },
        watch: {
            'formdata.name': {
                deep: true,
                handler: function (newVal, oldVal) {
                    if(this.formdata.name==''){
                      this.formdata.spur = ''
                    }
                    this.getMarketList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
                }
            },
            'formdata.code': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getMarketList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
                }
            },
            'formdata.admin': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getMarketList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
                }
            },
            'formdata.shopName': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.sid = newVal
                    this.getMarketList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
                }
            },
        },
        methods: {

            //获取采购单
            getMarketList(page,rows,startTime,endTime){
                this.$Api.getMarketList({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    time: startTime,
                    endtime:endTime,
                    adminid: this.formdata.admin,
                    markcode:this.formdata.code,
                    customerid:this.formdata.spur,
                    status: 2,
                    state: 1,
                }).then(res => {
                    if(res.code==200){
                        this.page.total = res.count
                        this.pageData = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            modifyTime(time){
                this.valuedate[0]=time[0]
                this.valuedate[1]=time[1]
                this.getMarketList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
            },
            //分页
            onGongPageTotal(num){
                    this.getMarketList(num,this.page.rows,this.valuedate[0],this.valuedate[1])
            },
            //搜索
            searchCondition(){
               this.getMarketList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
            },
            checkis(data){
                this.formdata.spur=data.id
                this.formdata.name = data.name
                this.modela=false
            },
            //店铺列表
            getShopList() {
                var data = {
                    cid: this.cid,
                    page: 1,
                    rows: 1000,

                };
                this.$Api.getShopList(data).then(res => {
                    this.shopList = res.data;
                    this.formdata.shopName = JSON.parse(localStorage.getItem('shop')).id
                });
            },
            //获取客户列表
            getCustomerList(){
                this.$Api.getCustomerList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000
                }).then(res => {
                    if(res.code==200){
                        this.customerList = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            //获取业务员列表
            getAdminList(){
                this.$Api.getAdminList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                    isdel:0
                }).then(res => {
                    if(res.code==200){
                        this.salesman =  res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .historyItem{
        width: 450px;
        height: 210px;
        background-color: #ffffff;
        box-shadow: 0px 3px 10px 0px
        rgba(24, 54, 129, 0.14);
        border-radius: 10px;
        display: inline-block;
        margin: 18px;
        cursor: pointer;
        .typeitem{
            display: block;
            width: auto;
            height: 30px;
            text-align: center;
            line-height: 30px;
            position: relative;
            top: -3px;
            right: -3px;
            padding-left: 5px;
            padding-right: 5px;
            border-radius: 4px;

            background-color: #fff2e5;
            border: solid 1px #ffaf5e;
            color: #ffaf5e;
        }
        .type-content{
            li{
                height: 30px;
            }
        }
        .typeitems{
            background-color: #fff2e5;
            border: solid 1px #ffaf5e;
            color: #ffaf5e;
        }
    }
    .ywy{
        text-align: right;
        padding-top: 10px;
    }
</style>